import React, { createRef, useEffect, useState } from "react";
import AdminTable from "./adminTable";
import AdminToolBar from "./adminToolbar";
import AdminHeader from "./adminHeader";
import { usePartners } from "../context/partners";
import { useInvitations } from "../context/invitations";
import { useApplications } from "../context/applications";
import { useEvents } from "../context/events";
import { usePromos } from "../context/promos";
import { HEADERS } from "../utils/constants";
import Partner, { EditPartner } from "./partner";
import Promo, { PromoModal } from "./promo";
import EventRow, { EventModal } from "./EventAdmin";
import Application, { EditApplicationModal } from "./application";
import { Modal } from "bootstrap";
import Invitation, { InvitationModal } from "./invitation";
import { CreatePartner } from "./modals";
import { filterApplication, filterEvent, filterInvitation, filterPartner, filterPromo } from "../utils/utils";

function Admin() {
    const { partners } = usePartners()
    const { invitations } = useInvitations()
    const { applications } = useApplications()
    const { events } = useEvents()
    const { promos, isLoading } = usePromos()

    const [content, setContent] = useState('socios')
    const [search, setSearch] = useState('')

    const modalRef = createRef()

    const showModal = () => {
        const modalEle = modalRef.current
        const bsModal = new Modal(modalEle, {
            backdrop: 'static',
            keyboard: false
        })
        bsModal.show()
    }

    const hideModal = () => {
        const modalEle = modalRef.current
        const bsModal = Modal.getInstance(modalEle)
        bsModal.toggle()
    }

    const DataTable = ({ title }) => {
        if (title === 'invitaciones') return <AdminTable header={HEADERS['invitaciones']} items={invitations} filter={search} row={Invitation} modal={InvitationModal} filterFunction={filterInvitation} />
        if (title === 'solicitudes') return <AdminTable header={HEADERS['solicitudes']} items={applications} filter={search} row={Application} modal={EditApplicationModal} filterFunction={filterApplication} />
        else if (title === 'eventos') return <AdminTable header={HEADERS['eventos']} items={events} filter={search} row={EventRow} modal={EventModal} filterFunction={filterEvent}/>
        else if (title === 'promociones') return <AdminTable header={HEADERS['promos']} items={promos} filter={search} row={Promo} modal={PromoModal} filterFunction={filterPromo}/>
        return <AdminTable header={HEADERS['socios']} items={partners} filter={search} row={Partner} modal={EditPartner} filterFunction={filterPartner}/>
    }

    const numberOfItems = () => {
        if (content === 'invitaciones') return invitations.length
        if (content === 'solicitudes') return applications.length
        else if (content === 'eventos') return events.length
        else if (content === 'promociones') return promos.length
        return partners.length
    }

    return (
        <div className="d-flex flex-column bg-white" style={{ minHeight: '100%' }}>

            <AdminHeader setContent={setContent} />

            {isLoading ?
                <span>Loading...</span>
                :
                <div className="container p-3">
                    <AdminToolBar title={content} numberOfItems={numberOfItems()} filter={search} setFilter={e => setSearch(e.target.value)} showModal={showModal} />

                    <DataTable title={content} />
                    {content === 'invitaciones' ? <CreatePartner data={null} hideModal={hideModal} ref={modalRef} /> : null}
                    {content === 'eventos' ? <EventModal data={null} hideModal={hideModal} ref={modalRef} /> : null}
                    {content === 'promociones' ? <PromoModal data={null} hideModal={hideModal} ref={modalRef} /> : null}
                </div>
            }

        </div>
    );
};

export default Admin;